declare var _root_url: string;

export function mapUrl(url: string) {
    return _root_url + url;
}